import { MarkerLocation } from '../Interfaces'

/** Prefer lat/lng; some payloads use latitude/longitude only. */
export function rawLatLng(marker: MarkerLocation): { lat: number; lng: number } | null {
  const lat = marker.lat ?? marker.latitude
  const lng = marker.lng ?? marker.longitude
  if (lat == null || lng == null) return null
  const nLat = Number(lat)
  const nLng = Number(lng)
  if (!Number.isFinite(nLat) || !Number.isFinite(nLng)) return null
  if (nLat === 0 && nLng === 0) return null
  return { lat: nLat, lng: nLng }
}

export function orderedWalkMarkers(markers: MarkerLocation[] | undefined): MarkerLocation[] {
  return [...(markers || [])].sort(
    (a, b) => (Number(a.label) || 0) - (Number(b.label) || 0),
  )
}

/** GPS fix exists for this marker (not null, not 0,0 placeholder). */
export function hasRealMarkerGps(marker: MarkerLocation | undefined): boolean {
  if (!marker) return false
  return rawLatLng(marker) != null
}

/**
 * Real GPS when present; otherwise a small ring around `fallback` so every stop is visible on the map.
 */
export function displayLatLngForMarker(
  marker: MarkerLocation,
  fallback: google.maps.LatLngLiteral,
  index: number,
  total: number,
): google.maps.LatLngLiteral {
  const real = rawLatLng(marker)
  if (real) return real
  const angle = (index * 2 * Math.PI) / Math.max(total, 1)
  const d = 0.00014 * (index + 1)
  return {
    lat: fallback.lat + d * Math.cos(angle),
    lng: fallback.lng + d * Math.sin(angle),
  }
}

export function centerForModal(
  marker: MarkerLocation,
  site: google.maps.LatLngLiteral,
): google.maps.LatLngLiteral {
  return displayLatLngForMarker(marker, site, 0, 1)
}
